/* Uses .inherit-link to scan for the first link it finds. This makes a div with a link inside clickable */
export function inheritLinks() {
  var inheritLinks = document.querySelectorAll(
    ".inherit-link, .bounce-inherit-link"
  );

  let i;
  inheritLinks.forEach(function (links) {
    if (!links.classList.contains("disable__link")) {
      // Search for parent node

      if (links.classList.contains("bounce-inherit-link")) {
        links = links.parentNode;
      }

      // Loop around click event, get ref and redirect window
      links.addEventListener("click", function () {
        let getLink = links.querySelector("a");

        // Identify _blank
        if(getLink) {
          if (getLink.target == "_blank") {
            window.open(getLink.href, "_blank");
          } else {
            location.href = getLink.href;
          }
        }
      });
    }
  });
}
